<button
  mat-button
  type="button"
  aria-label="close"
  class="qaroni-close-icon"
  [mat-dialog-close]="false"
  tabindex="-1">
  <mat-icon>close</mat-icon>
</button>

<div
  mat-dialog-title
  class="mat-mdc-dialog-title flex items-center justify-center gap-x-2">
  <mat-icon [color]="fileIconColor">
    {{ fileIcon }}
  </mat-icon>
  {{ title | fileNameTruncate: 25 }}
</div>

<mat-dialog-content class="flex flex-col gap-2">
  <div
    class="relative flex size-full items-center justify-center border bg-slate-50">
    @if (fileCategory === 'image') {
      <ng-container *ngTemplateOutlet="TImage" />
    } @else if (fileCategory === 'pdf') {
      <ng-container *ngTemplateOutlet="TPdf" />
    } @else if (fileCategory === 'office') {
      <ng-container *ngTemplateOutlet="TOffice" />
    } @else {
      <ng-container *ngTemplateOutlet="TUnknown" />
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="!mt-4 !flex justify-between gap-2 px-6">
  <div class="flex gap-1">
    <button
      mat-mini-fab
      type="button"
      aria-label="zoomOut"
      color="none"
      [disabled]="!canZoom"
      (click)="zoomOut()">
      <mat-icon>zoom_out</mat-icon>
    </button>
    <button
      mat-mini-fab
      type="button"
      aria-label="zoomIn"
      color="none"
      [disabled]="!canZoom"
      (click)="zoomIn()">
      <mat-icon>zoom_in</mat-icon>
    </button>
    <button
      mat-mini-fab
      type="button"
      aria-label="resetZoom"
      color="none"
      [disabled]="!canZoom"
      (click)="resetZoom()">
      <mat-icon>fullscreen_exit</mat-icon>
    </button>
  </div>

  <button
    mat-mini-fab
    type="button"
    aria-label="download"
    color="none"
    (click)="downloadFile()">
    <mat-icon>download</mat-icon>
  </button>
</mat-dialog-actions>

<ng-template #TUnknown>
  <div class="flex size-full flex-col items-center justify-center gap-2">
    <mat-icon class="large-icon">insert_drive_file</mat-icon>
    <div class="text-center">
      <h3 i18n>Formato no soportado para vista previa</h3>
      <p i18n>Este tipo de archivo no puede mostrarse en el visor.</p>
    </div>
  </div>
</ng-template>

<ng-template #TImage>
  <img [src]="safeFileUrl" [alt]="data.fileName" class="file-preview-image" />
</ng-template>

<ng-template #TPdf>
  <embed
    [src]="safeFileUrl"
    class="size-full"
    title="PDF Viewer"
    type="application/pdf"
    sandbox="allow-scripts allow-same-origin"
    allow="fullscreen" />
</ng-template>

<ng-template #TOffice>
  <div class="flex size-full flex-col items-center justify-center gap-2">
    <mat-icon class="qaroni-mat-icon-36">description</mat-icon>
    <div class="text-center">
      <h3 i18n>Vista previa no disponible</h3>
      <p i18n>Este tipo de archivo no se puede previsualizar directamente.</p>
      <p class="italic" i18n>
        Puedes descargarlo para abrirlo con la aplicación correspondiente.
      </p>
    </div>
  </div>
</ng-template>
